// extracted by mini-css-extract-plugin
export default {"thirdParty":"styles_thirdParty__8oOR1","address":"styles_address__p36X+"};